import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Qualifications from './pages/Qualifications'
import Cases from './pages/Cases'
import News from './pages/News'
import Contact from './pages/Contact'
import Disclosure from './pages/Disclosure'
import Careers from './pages/Careers'

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/qualifications" element={<Qualifications />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/news" element={<News />} />
          <Route path="/disclosure" element={<Disclosure />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App 